import React from "react";

export default function LineHr({ width = "w-1/3" }) {
  return <div className="line h-0.5 w-full"></div>;
}
